import { node, arrayOf, oneOfType } from 'prop-types';
import { components } from 'react-select';

const Menu = ({ children, ...rest }) => (
  <div data-testid='menu'>
    <components.Menu {...rest}>{children}</components.Menu>
  </div>
);

Menu.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired
};

export default Menu;
